// TamaraReturnBase.js
import React from "react";
import "./TamaraReturnPages.scss";

const TamaraReturnBase = ({ iconClass, title, message, buttonText, buttonAction }) => {
  return (
    <div className="tamara-return-container text-center py-5">
      <div className="tamara-icon mb-4">
        <i className={`fa ${iconClass} fa-5x`} aria-hidden="true"></i>
      </div>
      <h2 className="tamara-title mb-3">{title}</h2>
      <p className="tamara-message mb-4">{message}</p>
      <button className="btn btn-primary rounded-pill px-4" onClick={buttonAction}>
        {buttonText}
      </button>
    </div>
  );
};

export default TamaraReturnBase;
